export default __webpack_public_path__ + "static/media/place-holder.db21585a.jpg";